// P10 (ADR-0016): the mapping dialog's one request. ProDoc reads the file; TDS Reco's
// re-parse previews the mapping in ProDoc, saves it as the client's column map under
// `name`, and re-reads the file with it — so the dialog sends the name here and makes no
// second "save profile" call (one map, not two).

export interface ReparseBody {
  kind: 'statement' | 'ledger'
  sheet: string | null
  header_row: number
  column_map: Record<string, string>
  name: string
}

/** The re-parse body: only the bound fields, and a default name from the file's. */
export function reparseBody(
  kind: 'statement' | 'ledger',
  sheet: string | null | undefined,
  headerRow: number,
  mapping: Record<string, string | null>,
  profileName: string,
  filename: string,
): ReparseBody {
  const columnMap = Object.fromEntries(
    Object.entries(mapping).filter(([, v]) => v) as [string, string][],
  )
  return {
    kind,
    sheet: sheet ?? null,
    header_row: headerRow,
    column_map: columnMap,
    name: profileName.trim() || `${kind} format (${filename.slice(0, 40)})`,
  }
}
